import { makeAutoObservable, runInAction } from 'mobx';
import { IUserDto } from '../shared/interfaces';
import UsersApiService from '../services/api/UsersApiService';

class UserStore {
    public isLoading = false;
    public user: IUserDto | null = null;
    public error: string | null = null;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    // 🔹 Загрузка профиля текущего пользователя
    public async getProfile() {
        this.isLoading = true;
        this.error = null;
        try {
            const data: IUserDto = await UsersApiService.getProfile();
            runInAction(() => {
                this.user = data;
            });
        } catch (e: any) {
            console.error('Error loading user profile:', e);
            runInAction(() => {
                this.error = e?.message || 'Failed to load user profile';
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    // 🔹 Сброс пользователя
    public clear() {
        this.user = null;
        this.error = null;
        this.isLoading = false;
    }
}

export default new UserStore();
